// Phygital Icon - Using exact brand asset image with black background
// Now supports dynamic logo from Company Settings
import { Link } from "react-router-dom";
import { useCompanySettings } from "@/hooks/useCompanySettings";

// NEW LOGO ASSETS - Updated Jan 18, 2026
const PHYGITAL_ICON_DARK = "https://customer-assets.emergentagent.com/job_pref-layer/artifacts/sut1njwt_1.png"; // Icon on dark bg
const PHYGITAL_ICON_LIGHT = "https://customer-assets.emergentagent.com/job_pref-layer/artifacts/ptr9cb8h_2.png"; // Icon on light bg
const PHYGITAL_LOGO_DARK = "https://customer-assets.emergentagent.com/job_pref-layer/artifacts/526eicqa_1.png"; // Full logo on dark bg
const PHYGITAL_LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_pref-layer/artifacts/ayrejhsb_2.png"; // Full logo on light bg
// Profile avatar placeholder - black icon (use with CSS invert for white on dark backgrounds)
export const PHYGITAL_AVATAR_BLACK = "https://customer-assets.emergentagent.com/job_provider-phygital/artifacts/lfwmex62_phygital%20transparent%20background%20-%20black%20avi.png";

const PhygitalIcon = ({ className = "w-10 h-10", variant = "dark", showBox = false }) => {
  const { settings } = useCompanySettings();
  // Use admin-uploaded logo if available, otherwise default brand asset
  const hasCustomLogo = settings.logo_url && settings.logo_url.trim() !== "";
  const iconSrc = hasCustomLogo ? settings.logo_url : (variant === "light" ? PHYGITAL_ICON_LIGHT : PHYGITAL_ICON_DARK);
  
  if (!showBox) {
    return (
      <img 
        src={iconSrc}
        alt={settings.company_name || "phygital"}
        className={`${className} object-contain`}
      />
    );
  }
  return (
    <div className={`${className} rounded-xl flex items-center justify-center`}>
      <img 
        src={iconSrc}
        alt={settings.company_name || "phygital"}
        className="w-full h-full object-contain"
      />
    </div>
  );
};

// Full logo with text
export const PhygitalLogo = ({ className = "h-8", variant = "dark" }) => {
  const { settings } = useCompanySettings();
  const hasCustomLogo = settings.logo_url && settings.logo_url.trim() !== "";
  const logoSrc = hasCustomLogo ? settings.logo_url : (variant === "light" ? PHYGITAL_LOGO_LIGHT : PHYGITAL_LOGO_DARK);
  return (
    <img 
      src={logoSrc}
      alt={settings.company_name || "phygital"}
      className={`${className} object-contain`}
    />
  );
};

// Powered by footer component - CLICKABLE to home - uses icon
export const PoweredByPhygital = ({ className = "", variant = "light" }) => {
  const { settings } = useCompanySettings();
  return (
    <Link 
      to="/"
      onClick={() => window.scrollTo(0, 0)}
      className={`flex items-center justify-center gap-2 text-gray-400 text-sm hover:text-gray-600 transition-colors ${className}`}
    >
      <span>powered by</span>
      <PhygitalIcon className="w-7 h-7" variant={variant} />
      <span className="font-semibold text-gray-600">{settings.company_name?.toLowerCase() || "phygital"}</span>
    </Link>
  );
};

export default PhygitalIcon;
